/* eslint-disable */

import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';




export const SvgSearch = ({ size }) => {
    return (<Svg

        height={size}
        width={size}
        viewBox="0 0 360.4 360.4">
        <G>
            <Circle class="st0" fill="#E2E2E2" cx="180.2" cy="180.2" r="177.8" />
            <Path class="st1" fill="#FFFFFF" d="M271,89.4L271,89.4c7.7,7.7,7.7,20.2,0,27.9L117.3,271c-7.7,7.7-20.2,7.7-27.9,0l0,0c-7.7-7.7-7.7-20.2,0-27.9 L243.1,89.4C250.8,81.6,263.3,81.6,271,89.4z" />
            <Path class="st1" fill="#FFFFFF" d="M89.4,89.4L89.4,89.4c7.7-7.7,20.2-7.7,27.9,0L271,243.1c7.7,7.7,7.7,20.2,0,27.9l0,0c-7.7,7.7-20.2,7.7-27.9,0L89.4,117.3C81.6,109.6,81.6,97.1,89.4,89.4z" />
        </G>

    </Svg>)
}

